module.exports = require('./helpers/bundle-url').getBundleURL('QXyrT') + "chevron-left.896bdcc6.svg";